import { Component, ViewChild, inject, signal, Input } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { ROTATE } from 'src/app/shared/animations/rotate-animation';
import { navigationButtons } from '../../lists/navigation-buttons-list';
import { AuthService } from 'src/app/modules/login/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [ROTATE],
})
export class HeaderComponent {
  @Input() disableNavigationBtns: boolean = false;

  @Input() visibleActions: boolean = true;

  private _auth = inject(AuthService);

  public rotationIconSignal = signal(true);

  public navigationButtons = navigationButtons;

  @ViewChild('menuTrigger') trigger: MatMenuTrigger;

  constructor(public _layout: LayoutService) {
    this._layout.onNavClick();
  }
  /** Update signal and navigate to path
   * @param path clicked path
   */
  public onNavigationBtnClick(path: string) {
    this._layout.onNavClick(path);
  }

  /** Exacute animation */
  public rotate() {
    this.rotationIconSignal.update((val) => !val);
  }

  /** Open mat menu */
  public openMenu() {
    this.trigger.openMenu();
  }

  /** Close mat menu */
  public closeMenu() {
    this.trigger.closeMenu();
  }

  /** Logout from application, behind a confirmation */
  public logout() {
    this._layout.confirmLogout();
  }
}
